import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import store from "./state/store";
import plugins from './plugins';
import i18n from "./i18n";
import api from './services/api';
import { hasPermission } from './helpers/permission.js';
import * as helpers from './helpers/helpers.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';
import "../src/design/app.scss";
import './assets/css/custom.css';
import EntriesPerPage from '@/components/common/EntriesPerPage.vue';
import SyncingBtn from '@/components/common/SyncingBtn.vue';
import SortingColumn from './components/common/SortingColumn.vue';
import CustomDateRange from '@/components/common/CustomDateRange.vue';
import { notify } from '@kyvg/vue3-notification';

const app = createApp(App);

// Global properties
app.config.globalProperties.$http = api;
app.config.globalProperties.$hasPermission = hasPermission;
app.config.globalProperties.$helpers = helpers;
app.config.globalProperties.$publicFilePath = process.env.VUE_APP_API_BASE_URL;
app.config.globalProperties.$filePath = process.env.VUE_APP_API_BASE_URL+"/storage/";
app.config.globalProperties.$emptyValue = process.env.EMPTY_VALUE ?? "N/A";
app.config.globalProperties.$notify = notify;

// Apply plugins
plugins(app);

app.component('EntriesPerPage', EntriesPerPage);
app.component('SyncingBtn', SyncingBtn);
app.component('SortingColumn', SortingColumn);
app.component('CustomDateRange', CustomDateRange);
app.use(store)
   .use(router)
   .use(i18n)
   .mount('#app');
